import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const ViewUser = () => {

  useEffect(() => {
    var scriptUrls = [];


    scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];
    // Wait until data is loaded



    let isCancelled = false;


    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);


  const [userIdToDelete, setuserIdToDelete] = useState(null);

  const navigator = useNavigate();
  const handleUpdateClick = (e, id, userTypes) => {
    e.preventDefault();
    // Navigate to /page2 and pass the value
    // if (userTypes === "Receptionists") {
    //   navigator('/admin-update', { state: { uata: id } });
    // }

    if (userTypes === "Nurse" || userTypes === "Doctor" || userTypes === "Technician" || userTypes === "Admin") {
      navigator('/admin-update', { state: { uata: id } });
    }
    else{
      navigator('/admin-update', { state: { uata: id } });
    }
    window.location.reload();
  };
  const handleViewClick = (e, id) => {
    e.preventDefault();
    // Navigate to /page2 and pass the value
    navigator('/', { state: { uata: id } });
    window.location.reload();
  };
  const handleDateChange = (dob) => {
    const isoDate = dob; // "2025-04-25"
    const [year, month, day] = isoDate.split("-");
    const formatted = `${day}/${month}/${year}`; // "25/04/2025"
    return (formatted); // now dob is in the format backend expects
  };
  const handleDeleteClick = (e, id) => {
    e.preventDefault();
    // Deletes the department
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/delete-department/${id}`;

    axios.post(REST_API_BASE_URL)
      .then((response) => {
        console.log(response.data);
        window.alert(`This happend with: ${response.data}`);

        // After deletion, redirect to another page (e.g., home or item list)
        navigator("/view-doctors"); // Navigates back to the homepage or another route
      })
      .catch((error) => {
        window.alert("Error occurred while deleting the item.");
        console.error(error);
      });
  };

  const handleDeleteAll = (e) => {
    e.preventDefault();
    // Show confirmation dialog
    const confirmDelete = window.confirm(
      `Are you sure you want to delete all items?`
    );

    if (confirmDelete) {
      // If confirmed, perform the delete action
      const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/deleteAllBooks`;

      axios
        .post(REST_API_BASE_URL)
        .then((response) => {
          console.log(response.data);
          window.alert(`This happend with: ${response.data}`);

          // After deletion, redirect to another page (e.g., home or item list)
          navigator("/view-doctors"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          window.alert("Error occurred while deleting the item.");
          console.error(error);
        });
    } else {
      // If cancelled, do nothing (or show a cancellation message)
      window.alert("Deletion cancelled");
      navigator("/view-doctors");
    }
  }
  /* const dummyData =[
      {
          "id":1,
          "users":"Gautam Kumar",
          "title":"Dam it",
          "author":"Rest Api",
          "isbn":"isbn34546",
          "description":"This is really good",
          "backCover":"file1.jpg"
      }
  ] */
  const [users, setUsers] = useState([]);
  const srcImg = "http://localhost:8080/Images/";
  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/users`;
    const UserListSer = () => axios.get(REST_API_BASE_URL);
    UserListSer().then((response) => {
      setUsers(response.data);
      mainClass();
    }).catch(error => {
      console.error(error);
    })
  }, [])

  function mainClass() {
    const tableBody = document.querySelector('#scrollVertical tbody');
    const allRows = tableBody.querySelectorAll('tr');

    // If there are more than one rows AND any have "dataTables_empty", remove it
    if (allRows.length > 1) {
      allRows.forEach((row) => {
        if (row.classList.contains('odd')) {
          row.remove();
        }
      });
    }
  }
  const handleSoftDelete = (userId) => {
    axios.delete(`http://localhost:8080/webnet-hms/api/users/${userId}`)
      .then((response) => {
        alert('Department marked as deleted');
        setUsers((prevUsers) =>
          prevUsers.filter((prev) => prev.userId !== userId)
        ); // Remove the department from the state to hide it
      })
      .catch((error) => {
        console.error('Error marking department as deleted:', error);
      });
  };


  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#!">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Users</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Users list
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="card-title">Users List</h5>
                <a href="/admin-add" className="btn btn-primary ms-auto">Add User</a>
              </div>
              <div className="card-body">
                {/* Table starts */}
                <div className="table-responsive">
                  <table id="scrollVertical" className="table m-0 align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>User Type</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>DOB</th>
                        <th>Actions</th>
                      </tr>
                    </thead><tbody>
                      {users.map((user, index) => (
                        <tr key={index}>
                          <td>{user.userId}</td>
                          <td>
                            {user.firstName + ' ' + user.lastName}
                          </td>
                          <td>{user.roleName}</td>
                          <td>{user.phone}</td>
                          <td>{user.email}</td>
                          <td>{user.dob}</td>
                          <td>
                            <div className="d-inline-flex gap-1">

                              {/* <button
                                className="btn btn-outline-danger btn-sm rounded-5 me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#delRow"
                                onClick={() => setuserIdToDelete(user.userId)}
                              >
                                <i className="ri-delete-bin-line" />
                              </button> */}
                              <button
                                type="button"
                                className="btn btn-outline-success btn-sm"
                                title="Edit User"
                                onClick={(e) => handleUpdateClick(e, user.userId, user)}
                              >
                                <i className="ri-edit-box-line" />
                              </button>

                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                  </table>
                </div>
                {/* Table ends */}
                {/* Modal Delete Row */}
                <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                  <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="delRowLabel">
                          Confirm
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                      </div>
                      <div className="modal-body">
                        Are you sure you want to delete the staff member?
                      </div>
                      <div className="modal-footer">
                        <div className="d-flex justify-content-end gap-2">
                          <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>

                          <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleSoftDelete(userIdToDelete)}>Yes</button>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>

  );

}

export default ViewUser;




